export const IS_CYPRESS_ENVIRONMENT =
  process.env.REACT_APP_WRAPPER === 'cypress'

export const TEST_DATA_ATTR = 'data-cy'

export const SPACING = 8

export const STORE_NAME = {
  PRODUCTS: 'products',
  PRODUCTS_STATS: 'productsStats',
  SALES: 'sales',
  ACQUISITIONS: 'acquisitions',
  BUDGET: 'budget',
  CASHBOX_HISTORY: 'cashboxHistory',
  CUSTOMERS: 'customers',
  CUSTOMERS_STATS: 'customersStats',
  USERS: 'users',
  USERS_STATS: 'usersStats',
  GROUPS: 'groups',
  SUPPLIERS: 'suppliers',
  SUPPLIERS_STATS: 'suppliersStats',
  STATS: 'stats',
  STICKERS: 'stickers',
  LOGS: 'logs',
  EVENTS: 'events',
  ERRORS: 'errors',
}

export const INDEX_NAME = {
  NAME_MODEL: 'nameModel',
  DATETIME: 'datetime',
  NEEDED_SINCE_DATETIME: 'neededSinceDatetime',
  __CART_ID__: '__cartId__',
  CART_PARTICIPANTS: 'cartParticipants',
  ACTIVE_CART_ID: 'activeCartId',
  STICKERS_SELECTION_ID: 'stickersSelectionId',
  EVENT_DATETIME: 'eventDatetime',
  ERROR_DATETIME: 'errorDatetime',
  NAME: 'name',
}

export const TO_BUY_FILTER_OPTIONS = {
  ACTIVE: 'active',
  HAVE_TO_BUY: 'haveToBuy',
  BOUGHT: 'bought',
  FROZEN: 'frozen',
}

export const PRODUCTS_FILTER_OPTIONS = {
  ALL: 'all',
  IN_STOCK: 'inStock',
  SOLD_OUT: 'soldOut',
}

export const CASHBOX_OPERATION = {
  ADD: 'ADD',
  SUBTRACT: 'SUBTRACT',
}

export const CELL_TEXT_VERTICAL_POSITION = `
  align-self: center;
  line-height: 0;
  position: relative;
  top: -1px;
`
